export {
  default as firePit,
  ReactComponent as FirePit,
} from '@assets/icons/features-and-amenities/fire-pit.svg'    
